

const useFormikSearch = () => {
  const initialValues = {
    searchedName: "",
  };

  const onSubmit = () => {};

  return { initialValues, onSubmit };
};

export default useFormikSearch;
